//import { toggleModal } from "components/Stacker/actions/ModalActions"
//import { selectQuickViewProduct } from "components/Stacker/actions/ProductDetailActions"
import { addProduct } from "components/Stacker/actions/StackerActions"
import classNames from "classnames"
// import classNames from 'classnames';
//import ModalConfig from "components/Stacker/config/ModalConfig"
import { gsap, Power4, Draggable } from "gsap/all"
//import { Draggable } from "gsap/Draggable"
import isMobile from "components/Stacker/utils/device-check"
import PropTypes from "prop-types"
// import Gesture from 'rc-gesture';
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react"
import { getIsMensExperience } from "../../Common/helpers"
import "./BraceletItem.scss"
//import { getFadedButtonStyles } from "components/DYStackers/styles"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import iconDragSvgText from "assets/icons/icon-drag.svg"
import removeSvgText from "assets/temp/icons/icon-remove-amulet2.svg"
import { InlineRefSVGIcon, InlineSVGIcon } from "components/Stacker/SvgIcon"
import { stacker } from "../../../../../reducers"
import { StackerContext } from "../../../../DYStackers/StackerContext"

gsap.registerPlugin(Draggable)

function BraceletItem({
  autoStart,
  delay,
  duration,
  isRearrange,
  id,
  inFocus,
  src,
  to,
  onBraceletStart,
  onDrag,
  onDragEnd,
  onItemMouseOver,
  onItemMouseOut,
  onLoad,
  onUnmount,
}) {
  //const isRearrange = useSelector((state) => state.stacker.isRearrange)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const [canRemove, setCanRemove] = useState(false)
  const [isDragging, setIsDragging] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const [currentTo, setCurrentTo] = useState(0)
  const [isInitialized, setIsInitialized] = useState(false)
  const ref = useRef()
  const drag = useRef()
  const imgRef = useRef()
  const hitRef = useRef()

  const animate = useCallback(() => {
    setCurrentTo(to)

    gsap.to(ref.current, {
      y: to,
      delay,
      ease: Power4.easeOut,
      duration,
      onStart: onBraceletStart,
    })
  }, [delay, duration, onBraceletStart, to])

  useEffect(() => {
    if (!ref.current) {
      return
    }
    setIsInitialized(true)
    const draggable = Draggable.create(ref.current, {
      trigger: hitRef.current,
      type: "y",
      onRelease() {
        gsap.set(imgRef.current, { css: { zIndex: -1 * to } })
      },
      onDragEnd: () => {
        onDragEnd()
        setIsDragging(false)
        //animate()
        setTimeout(() => setCanRemove(true), 4000)
      },
      onDrag: () => {
        const yPos = window
          .getComputedStyle(ref.current)
          .getPropertyValue("transform")
          .match(/(-?[0-9.]+)/g)[5]

        onDrag(id, yPos)
      },
      onDragStart: () => {
        setCanRemove(false)
        setIsDragging(true)
        //animate()
        gsap.to(ref.current, { css: { zIndex: 100 } })
      },
    })
    drag.current = draggable
    isRearrange ? drag.current[0].enable() : drag.current[0].disable()
    return () => {
      drag.current[0].kill()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animate, id, onDrag, onDragEnd])

  useEffect(() => {
    if (isRearrange) {
      setCanRemove(true)
      drag.current && drag.current[0].enable()
    } else {
      drag.current && drag.current[0].disable()
    }
  }, [isRearrange])

  useEffect(() => {
    if (autoStart && to !== currentTo && !isDragging) {
      animate()
    }
  }, [animate, autoStart, currentTo, isDragging, to])

  useEffect(() => {
    return () => {
      onUnmount(id)
    }
  }, [id, onUnmount])

  const onMouseOver = useCallback(() => {
    onItemMouseOver(id)
  }, [id, onItemMouseOver])

  const onMouseOut = useCallback(() => {
    if (
      StackerContext.gender == "men" &&
      !isDragging &&
      !isRearrange &&
      inFocus === "neutral"
    ) {
      return
    }
    onItemMouseOut()
  }, [inFocus, isDragging, isRearrange, onItemMouseOut])

  const handleOnLoad = useCallback(() => {
    if (isLoaded) {
      return
    }

    setIsLoaded(true)
    onLoad(id, imgRef.current.clientHeight)
  }, [id, isLoaded, onLoad])

  useLayoutEffect(() => {
    if (imgRef.current.complete) {
      handleOnLoad()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src])

  const onRemoveClick = useCallback(() => {
    if (canRemove && isRearrange) {
      dispatch(addProduct(id, location, navigate))
    }
    onMouseOut()
  }, [canRemove, dispatch, id, isRearrange, location, navigate, onMouseOut])

  // const onViewDetailsClick = useCallback(
  //   (e) => {
  //     const { pid, url } = e.currentTarget.dataset
  //     dispatch(selectQuickViewProduct(pid, url))
  //     dispatch(toggleModal(ModalConfig.MODAL_QUICK_VIEW, true))
  //   },
  //   [dispatch]
  // )

  const classes = classNames("product_bracelet", {
    "no-focus": inFocus === "no",
  })

  const zIndex = isRearrange && inFocus ? 100 : -1 * to

  return (
    <div
      className={classes}
      ref={ref}
      onMouseEnter={isRearrange && inFocus ? onMouseOver : () => null}
      onMouseLeave={!isDragging ? onMouseOut : () => null}
      id={id.replace(/ /, "-")}
      style={{ zIndex: zIndex }}
    >
      <>
        {/* <img
          alt="Drag"
          className={`icon-drag icon-drag-${id.replace(/ /, "-")}`}
          src={`assets/icons/icon-drag.svg`}
          width="32"
        /> */}
        <InlineRefSVGIcon
          ref={hitRef}
          alt="Drag"
          className={`icon-drag icon-drag-${id.replace(/ /, "-")}`}
          style={{
            width: 32,
          }}
          iconSvgText={iconDragSvgText}
        />
        {/* <div /> */}
        <button
          className="btn btn-icon remove-bracelet"
          onFocus={() => null}
          onMouseOver={onMouseOver}
          onClick={onRemoveClick}
        >
          {/* <img alt="Remove" src={`assets/temp/icons/icon-remove-amulet.svg`} /> */}
          <InlineSVGIcon
            alt="Remove"
            className=""
            iconSvgText={removeSvgText}
            // style={{
            //   height: 21,
            //   width: 21,
            // }}
          />
          {/* <removeSvg /> */}
        </button>
      </>
      <div>
        <img
          // id={id}
          className="bracelet-item"
          ref={imgRef}
          alt="Amulet"
          src={src}
          width="1040"
          onLoad={handleOnLoad}
          onError={handleOnLoad}
        />
      </div>
    </div>
  )
}

BraceletItem.propTypes = {
  autoStart: PropTypes.bool.isRequired,
  isRearrange: PropTypes.bool.isRequired,
  delay: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  inFocus: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  to: PropTypes.number.isRequired,
  onBraceletStart: PropTypes.func,
  onDrag: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  onItemMouseOver: PropTypes.func.isRequired,
  onItemMouseOut: PropTypes.func.isRequired,
  onLoad: PropTypes.func.isRequired,
  onUnmount: PropTypes.func.isRequired,
}

export default BraceletItem
